export const aboutData = {
    title: "Who I am",
    description1: "I'm Amir, and I currently work as a full stack developer.",
    description2: "Day to day I build web applications end to end: TypeScript APIs, React frontends, PostgreSQL databases, and the Docker, Kubernetes and Terraform setup that takes them to production. Outside of that I'm most interested in systems-level programming and cybersecurity: how operating systems, memory and networks work underneath, and how software gets broken and defended.",
    codingSince: 2019,
    stats: [
        { value: 4, prefix: '#', label: 'TryHackMe rank in Austria' },
    ]
}
